import React from 'react';
import { Link } from 'react-router-dom';
import colors from '../styles/colors';

function ProductsServices({ setActiveTab }) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200">
      <h2 className="text-2xl font-bold mb-4 text-indigo-950">Products and Services</h2>


      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-3 text-indigo-950 border-b-2 border-gold pb-2 inline-block">FACULTRA</h3>
        <div className="mb-4">
           <p> We have decades-long experience of automation in healthcare, finance and engineering and we pioneer a system that learns what really matters for each specific task.
           This enables us to explain our results, enhance our service continuously and tailor our services exactly to how you do, or would like to do, business.
          </p>
        </div>
      </section>


      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-3 text-indigo-950 border-b-2 border-gold pb-2 inline-block">Our Service</h3>
        <div className="mb-4">
          <p>
            To enhance your specialisation and expertise, it helps to learn about you.
          To solve your problems, we need to understand them first.
          </p>
          <p>
            That's why we give <span className="text-gold font-semibold">free automation and digitisation advice</span>. No strings attached. No time pressure. </p>
           <p> <p>
        <Link
          to="/contact"
          className="text-gold hover:text-yellow-700 underline font-semibold cursor-pointer"
        >
          Contact us
        </Link> to book a free online or in-person session.
      </p>
</p>
        </div>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold mb-3 text-indigo-950 border-b-2 border-gold pb-2 inline-block">Our Product</h3>
        <div className="mb-4">
          <p>
            <span className="text-gold font-semibold">POaaS</span>  - <span className="text-gold font-semibold">P</span><span className="text-indigo-950 font-semibold">rofessional</span> <span className="text-gold font-semibold">O</span><span className="text-indigo-950 font-semibold">utcome</span> <span className="text-gold font-semibold">a</span><span className="text-indigo-950 font-semibold">s</span> <span className="text-gold font-semibold">a</span> <span className="text-gold font-semibold">S</span><span className="text-indigo-950 font-semibold">ervice</span>: </p>
            <p>We tailor services to your needs. Think of us as your personal, expert tech department. </p>  <p> We handle all the risk and upfront costs. You pay nothing until you are happy with the results. After that, you only pay per completed task.
          </p>
        </div>
      </section>

    </div>
  );
}

export default ProductsServices;